export default "__VITE_ASSET__BDZtRNtC__"